import axiosInstance from "./axiosInstance";

export const DomainService = {
  getDomains: async (organizationId: string) => {
    const response = await axiosInstance.get(
      `/api/v1/organizations/${organizationId}/domains`
    );
    return response.data;
  },
  createDomain: async (organizationId: string, data: any) => {
    const response = await axiosInstance.post(
      `/api/v1/organizations/${organizationId}/domains?environment-id=${
        data.environmentID || ""
      }`,
      data
    );
    return response.data;
  },
  updateDomain: async (organizationId: string, domainId: string, data: any) => {
    const response = await axiosInstance.put(
      `/api/v1/organizations/${organizationId}/domains/${domainId}`,
      data
    );
    return response.data;
  },
  deleteDomain: async (organizationId: string, domainId: string) => {
    const response = await axiosInstance.delete(
      `/api/v1/organizations/${organizationId}/domains/${domainId}`
    );
    return response.data;
  },
  getDomain: async (organizationId: string, domainId: string) => {
    const response = await axiosInstance.get(
      `/api/v1/organizations/${organizationId}/domains/${domainId}`
    );
    return response.data;
  },
};
